import React from 'react';

import BackButtonLayout from './BackButtonLayout';

const BackButtonLayoutTitleAction = ({
  children,
  to,
  onBackClick,
  title = null,
  rightActions = null,
  subtitle,
}: {
  children?: React.ReactNode;
  to?: string;
  onBackClick?: () => void;
  title?: React.ReactNode;
  rightActions?: React.ReactNode | null;
  subtitle?: React.ReactNode;
}): JSX.Element => (
  <BackButtonLayout to={to} onBackClick={onBackClick}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: 3,
        marginBottom: 30,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {title && (
          <h1
            style={{
              fontSize: 24,
              display: 'flex',
              alignItems: 'center',
              margin: 0,
            }}
          >
            {title}
          </h1>
        )}
        {subtitle}
      </div>

      {rightActions}
    </div>
    {children}
  </BackButtonLayout>
);
export default BackButtonLayoutTitleAction;
